import {
  BlockWrapper,
  defineBlock,
  useEditor,
} from "@smartfire/js-block-engine";
import apiFetch from "@wordpress/api-fetch";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { Navigation, Autoplay, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { readingTime } from "../shared/tools.js";
import { NavButtons } from "./NavButtons";
import { Slide } from "./Slide";
import "swiper/css";
import "swiper/css/effect-fade";
import style from "./block.module.scss";

const Slider = ({ addClass = null, posts = [] }) => {
  const { isEditing } = useEditor();
  const [displayedPosts, setDisplayedPosts] = useState(posts);
  const swiperRef = useRef(null);

  const swiperSettings = {
    modules: [Navigation, Autoplay, EffectFade],
    speed: 500,
    effect: "fade",
    fadeEffect: { crossFade: true },
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 6000,
    },
  };

  const parseRestData = (res) => {
    let data = [];

    res.forEach((post) => {
      data.push({
        id: post.id,
        title: post.title?.rendered,
        thumbnail: {
          title:
            post._embedded["wp:featuredmedia"] &&
            post._embedded["wp:featuredmedia"][0].title.rendered,
          url:
            post._embedded["wp:featuredmedia"] &&
            post._embedded["wp:featuredmedia"][0].source_url,
          alt:
            post._embedded["wp:featuredmedia"] &&
            post._embedded["wp:featuredmedia"][0].alt_text,
        },
        image: post?.acf_fields?.image,
        author: post?.author_data.data.display_name,
        cat: post.categories_data.length > 0 && post.categories_data[0].name,
        catLink:
          post.categories_data.length > 0 && post.categories_data[0].link,
        date: post.date,
        link: post.link,
        excerpt: post.excerpt.rendered,
        reading_time: readingTime(post.content.rendered),
      });
    });

    return data;
  };

  // Display posts in BO
  useEffect(() => {
    if (!isEditing) return;

    const params = new URLSearchParams({
      page: 1,
      per_page: 4,
      order_by: "date",
    }).toString();

    apiFetch({
      path: "/wp/v2/posts?_embed&" + params,
    }).then((res) => {
      setDisplayedPosts(parseRestData(res));
    });
  }, [isEditing]);

  return (
    <BlockWrapper.Div className={clsx(style.block, addClass)}>
      <Swiper
        {...swiperSettings}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {displayedPosts.map((post, _) => (
          <SwiperSlide key={post.id}>
            <Slide post={post} />
          </SwiperSlide>
        ))}
      </Swiper>

      <NavButtons
        className={style.navButtons}
        onClickLeft={() => swiperRef.current?.slidePrev()}
        onClickRight={() => swiperRef.current?.slideNext()}
      />

      <div className={style.innerBorder} />
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: Slider,
  setup: {
    title: "Home Hero",
  },
});
